import { exchangeToken, queueCheck } from './api';

export interface AuthState {
  getToken: () => string | null;
  setToken: (t: string) => void;
  exchangeAndStore: (code: string) => Promise<void>;
  checkIsDj: () => Promise<boolean>;
}

export function createAuthState(): AuthState {
  let token: string | null = null;
  let djCache: boolean | null = null;

  return {
    getToken: () => token,
    setToken(t: string) {
      token = t;
      djCache = null;  // invalidate
    },
    async exchangeAndStore(code: string) {
      const { access_token } = await exchangeToken(code);
      token = access_token;
      djCache = null;
    },
    async checkIsDj() {
      if (djCache !== null) return djCache;
      if (token === null) return false;
      try {
        djCache = await queueCheck(token);
        return djCache;
      } catch {
        return false;
      }
    },
  };
}
